import React from 'react';
import icClose from 'Assets/img/ic_close_24_strong@2x.png';
import icQuestion from 'Assets/img/ic_question_line_20_basic@2x.png';
import IntlMessages from 'Util/IntlMessages';

const Faq = ({ faq, postFaq, setIsOpenFaq, refresh }) => {
  const renderFaq = faq => {
    return (
      <div className='customer-support-chat-faq-item cursor-pointer' key={faq._id} onClick={() => postFaq(faq._id, refresh)}>
        <div className='customer-support-chat-faq-item-question'>{faq.question}</div>
      </div>
    );
  };

  return (
    <div className='customer-support-chat-faq'>
      <div className='customer-support-chat-faq-header'>
        <div className='customer-support-chat-faq-header-close'>
          <img
            className='cursor-pointer'
            src={icClose}
            alt='close'
            style={{ width: '24px', height: '24px' }}
            onClick={() => {
              setIsOpenFaq(false);
              localStorage.setItem('closedFaq', true);
            }}
          />
        </div>
        <img src={icQuestion} alt='question' style={{ width: '20px', height: '20px' }} />
        <div className='customer-support-chat-faq-header-title-text'>
          <IntlMessages id='customer.support.chat.faq.title' />
        </div>
      </div>
      <div className='customer-support-chat-faq-list'>{faq.map(renderFaq)}</div>
    </div>
  );
};

export default Faq;
